module.exports = __webpack_public_path__ + "dc3e086fc0c5addc09702e111d2adb42.woff";